import { render, staticRenderFns } from "./OnboardingQuicktrialMobile.vue?vue&type=template&id=5b85e6e6&scoped=true&"
import script from "./OnboardingQuicktrialMobile.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuicktrialMobile.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingQuicktrialMobile.vue?vue&type=style&index=0&id=5b85e6e6&prod&lang=scss&scoped=true&"
import style1 from "./OnboardingQuicktrialMobile.vue?vue&type=style&index=1&id=5b85e6e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85e6e6",
  null
  
)

export default component.exports